// extracted by mini-css-extract-plugin
export default {"header":"header_header__DMQks","title":"header_title__26Rdt","logo":"header_logo__uofsJ","icons":"header_icons__yoB5K"};